import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, startWith } from 'rxjs/operators';

@Directive({
  selector: '[rdPreserveSvgMaskUrl]',
  standalone: true,
})
@UntilDestroy()
export class PreserveSvgMaskUrlDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private router = inject(Router);

  ngAfterViewInit(): void {
    this.router.events
      .pipe(
        filter((x) => x instanceof NavigationEnd),
        startWith(() => new NavigationEnd(1, '', '')),
        untilDestroyed(this),
      )
      .subscribe(() => this.applySvgFixes());
  }

  private applySvgFixes() {
    const element: Element = this.elementRef.nativeElement;
    if (element) {
      this.preserveSVGMaskUrl(element, 'clip-path');
      this.preserveSVGMaskUrl(element, 'mask');
      this.preserveSVGMaskUrl(element, 'fill');
    }
  }

  private preserveSVGMaskUrl(element: Element, attribute: string) {
    [].slice
      .call(element.querySelectorAll(`*[${attribute}]`))
      .filter(
        (element: Element) =>
          element.getAttribute(attribute)?.indexOf('url(') !== -1,
      )
      .forEach((element: Element) => {
        // Get the attr key, the format is `mask=url('url_key#original_mask_key')`
        const attrVal = element.getAttribute(attribute);
        // Slice out form position 5 or preserving the original `url('` prefix
        // till the # character.
        const maskedUrl = attrVal?.slice(5, attrVal.indexOf('#')) ?? '';
        // Remove `url_key` key from the attr
        const originalMaskURL = attrVal?.replace(maskedUrl, '') ?? '';

        element.setAttribute(attribute, originalMaskURL);
      });
  }
}
